export enum RestaurantTypeEnum {
    Creche,
    Maternelle,
    Elementaire,
    Adulte
}
